import { shallowComparison } from "client/Misc/compareUtils";
import { FrequentlyUsedTileModel, listFrequentlyUsedTiles } from "client/Api/Workspace/workspace";
import { useEffect } from "react";
import create, { UseStore } from "zustand";
import createVanilla, { StoreApi } from "zustand/vanilla";

export type FrequentlyUsedTilesStoreData = {
	items: readonly FrequentlyUsedTileModel[] | undefined;
	wasInitialized: boolean;
	ensureInitialized(): void;
};

const store: StoreApi<FrequentlyUsedTilesStoreData> = createVanilla(
	(set, get): FrequentlyUsedTilesStoreData => {
		return {
			items: undefined,
			wasInitialized: false,
			ensureInitialized: () => {
				if (get().wasInitialized) {
					return;
				}

				set({
					wasInitialized: true
				});

				listFrequentlyUsedTiles()
					.then(
						(items) => set({
							items
						}),
						() => set({
							items: []
						})
					);
			}
		};
	}
);

const useStore: UseStore<FrequentlyUsedTilesStoreData> = create(store);

export function useFrequentlyUsedTiles():
	[items: readonly FrequentlyUsedTileModel[] | undefined]
{
	const { items, ensureInitialized } = useStore(
		(x) => ({
			items: x.items,
			ensureInitialized: x.ensureInitialized
		}),
		shallowComparison
	);

	useEffect(
		(): void => {
			ensureInitialized();
		},
		[ensureInitialized]
	);

	return [items];
}
